export default __webpack_public_path__ + "static/media/werk.36e94180.png";